import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Assests/Scss/Scenario.scss";
import Loading from "../../../Student/Reusablecomponents/Loading";

import Search from "../../../ReusableComponents/Search";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { RiDeleteBin5Line } from "react-icons/ri";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
import { useSelector, useDispatch } from "react-redux";
import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import { useNavigate, useLocation } from "react-router-dom";
import { ScenarioData } from "../../../Redux/Reducers/QBAdmin/Editscenario";
import ScenarioDelete, { GetScenarioDetails,} from "../../../ReusableComponents/CommonApis";
import { CheckLanguage } from "../../../ReusableComponents/CommonFunctions";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import { FaRegEye } from "react-icons/fa";
import { GetQuestionByScenario } from "../../../ReusableComponents/QBAdmin/QBACommonApi";
import { FaClockRotateLeft } from "react-icons/fa6";
import { GetQuestionDetails, GetScienceQuestionDetails, QuestionPreview,} from "../../../ReusableComponents/CommonApis";
const Scenario = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector( (state) => state.SelectLanguageData.SLanguage);

  const [SearchSelection, SetSearchSelection] = useState( localStorage.getItem("FilterSelection") || "By Scenario Id(s)");
  const [SearchText, SetSearchText] = useState(localStorage.getItem("SearchSid") || []);
  const [ScenarioList, SetScenarioList] = useState(props.data);
  const [SelectFilters, SetSelectFilters] = useState( JSON.parse(localStorage.getItem("ByStatus")));
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(parseInt(location.state?.SList) || 1);
  const [Load, SetLoad] = useState(false);

  const handleFilterChange = (filter) => {
    if (SelectFilters.includes(filter)) {
      SetSelectFilters(SelectFilters.filter((f) => f !== filter));
    } else {
      SetSelectFilters([...SelectFilters, filter]);
    }
  };

  const ScenariosBySubject = async (PageNo, CStatus) => {
    SetCPage(PageNo);
    navigate(".", { state: { ...location.state, SList: PageNo } });
    SetLoad((prev) => !prev);
    await axios .get( process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetScenariosBySubject?SubjectId=${items?.subjectId
        }&PageNo=${PageNo}&PageSize=${PageCount}&IsUsedOrMapped=${SelectFilters?.join(",") || 0
        }&QBCategoryType=SCQ&LanguageId=${SelectLanguage}&TopicId=${location.state?.Topic || 0
        }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.scenarioID) {
          SetScenarioList(res.data);
        } else {
          SetScenarioList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => { console.log(err); });
  };
  useEffect(() => {
    if (SearchSelection === "By Question Id(s)" && SearchText?.length > 0) {
      GetQuestionByScenario(SearchText, items?.subjectId, SelectLanguage, SetScenarioList, SetLoad);
    }
    if (SearchText?.length > 0 && SearchSelection === "By Scenario Id(s)") {
      SearchById();
    } else
      if (!props.data && SelectLanguage && SearchSelection === "By Scenario Id(s)") {
        ScenariosBySubject(location.state?.SList || CPage);
      }
  }, [PageCount, SelectLanguage, location.state?.Topic]);

  const SearchById = async () => {
    // SetCPage(1);
    SetLoad((prev) => !prev);
    await axios.get( process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetScenarioByIds?SubjectId=${items?.subjectId}&ScenarioId=${SearchText}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.scenarioID) {
          SetScenarioList(res.data);
        } else {
          SetScenarioList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetLoad((prev) => !prev);
        notify("Please enter valid input", "warning");
      });
  };

  const GetFilterData = () => {
if(SearchSelection !== "By Status" && SearchText?.length > 0 && SearchText?.split(",").length > 20){
  notify("You can enter a maximum of 20 IDs only.", "warning");
  return
}

    if (SearchText.length > 0 || SelectFilters?.length > 0) {
      localStorage.setItem("FilterSelection", SearchSelection);
      if (SearchText.length > 0) {
        if (SearchSelection === "By Scenario Id(s)") { SearchById(); }
        if (SearchSelection === "By Question Id(s)") { GetQuestionByScenario(SearchText, items?.subjectId, SelectLanguage, SetScenarioList, SetLoad); }
      } else {
        localStorage.setItem("ByStatus", JSON.stringify(SelectFilters));
        ScenariosBySubject(1);
      }
    } else {
      notify(`${SearchSelection === "By Scenario Id(s)"
        ? `Please enter the "Scenario Id" to click Go button`
        : SearchSelection === "By Question Id(s)" ?
          `Please enter the "Question Id" to click Go button`
          : `Please select the "Status" to click Go button`
        }`, "warning");
    }
  };
  const BacktoNormaList = () => {
    if (SearchSelection === "By Question Id(s)") {
      SetSearchSelection("By Scenario Id(s)");
    }
    localStorage.removeItem("ByStatus");
    localStorage.removeItem("SearchSid");
    SetSearchText([]);
    SetSelectFilters([]);
    ScenariosBySubject(1, "0");
    localStorage.removeItem("FilterSelection");
  };
  const columns = [
    {
      name: "Scenario ID", selector: "scenarioID", sortable: true,
      cell: (row) => (<div className="LinkStyles" onClick={() => AddEditScenario(row)} title="Edit Scenario">{row.scenarioID} </div>),
    },
    {
      name: "Scenario", selector: "scenarioName", sortable: true,
      cell: (row) => (<div className="ScenarioList"> <ScenarioQuestionformat scenario={row.scenarioName} /> </div>),
    },
    {
      name: "Main Source", selector: "mainSourceLovId", sortable: true,
      cell: (row) => (<div> {row.mainSourceLovId === 3543 ? "Text book based" : "Non-text book based"} </div>),
    },
    {
      name: "Questions",
      cell: (row) => (
        <div className="dflex alignitems JCCenter" style={{ gap: "15px" }} >
          <div className=" dflex alignitems gap-2">
            <FaRegEye title="View Questions in Scenario" className="CPointer" onClick={() => NavigateQuestions(row)} style={{ color: "#624DE3" }} />
            ({row.questionCount}) </div>
          {!CheckLanguage(SelectLanguage) && (<RiDeleteBin5Line className="CPointer" style={{ color: "#FD3333" }} onClick={() => DeleteScenario(row)} />)}
        </div>
      ),
    },
  ];
  const DeleteScenario = async (Row) => {
    if (Row.questionCount > 0) {
      notify("Please delete all questions associated with the scenario before you could delete the scenario", "warning");
    } else {
      if (window.confirm("Are you sure you want to delete the scenario ?")) {
        ScenarioDelete(Row.scenarioID, dispatch, ScenariosBySubject(1));
      }
    }
  };
  const NavigateQuestions = (Row) => {
    dispatch(ScenarioData({ ScenarioDetails: Row }));
    if (JSON.parse(localStorage.getItem("LoFilters"))) {
      navigate("/QBAdmin/QuestionBank/FilterScenarioQuestions", { state: { Tab: location.state?.Tab, SID: Row?.scenarioID }, });
    } else {
      navigate("/QBAdmin/QuestionBank/ScenarioQuestions", { state: { Tab: location.state?.Tab }, });
    }
  };

  const AddEditScenario = (Row) => {
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchSid", SearchText);
    }
    GetScenarioDetails(SelectLanguage, Row.scenarioID, dispatch, navigate, SetLoad, location);
  };

  const ChangeFilter = (Search) => {
    if (Search !== "By Question Id(s)") {
      ScenariosBySubject(CPage);
    }
    SetSearchText([]);
    SetSelectFilters([]);
    SetSearchSelection(Search);
    localStorage.removeItem("FilterSelection");
  };

  const QuestionBased = [
    { name:"Scenario No(Id)",selector: "scenarioId", sortable: true,},
    {
      name: "Question No(Id)", selector: "questionID", sortable: true,
      cell: (row) => (
        <div className="LinkStyles" title="Edit Question" onClick={() => HandleQuestionDetails(row.questionID)} > {row.questionID} </div>
      ),
    },
    {
      name: "Question", selector: "question",
      cell: (row) => (<div className="ScenarioList">
        <ScenarioQuestionformat scenario={row.question} />
        {row.qType !== "D" &&
          // <div className="Options dflex"> <b>Answer :</b> <ScenarioQuestionformat scenario={row.answer} /> </div> :
          ["A", "B", "C", "D"].map((option, i) => (
            <div key={i} className="Options"
              style={option === row.answer ? { color: "green", fontWeight: "bold" } : {}} >
              <span className="dflex p-1">
                {option})&nbsp; <ScenarioQuestionformat scenario={row[`option${option}`]} />{" "}
              </span>
            </div>
          ))}
      </div>
      ),
    },
    {
      name: "Answer(s)", selector: "answer", sortable: true,
      cell: (row) => (<span className="dflex p-1">
        {row.answer}) &nbsp; <ScenarioQuestionformat scenario={row[`option${row.answer}`]} />{" "} </span>),
    },
    {
      name: "Question Verification Status", selector: "qbStatus", sortable: true,
      cell: (row) => (
        <div className="dflex flexd-column">
          <span>{row.qbStatus}</span>
          {/* <span className="LinkStyles" style={{ textWrap: "nowrap" }} onClick={() => SetStatusData(row.questionID)} >
            View Status Log </span> */}
        </div>
      ),
    },
    { name: "Used/Unused - Mapped/UnMapped", selector: "qStatus", sortable: true, },
    ...(items?.subjectId === "1" ? [{ name: "Original / Cloned", selector: "isClonedOrOriginal", sortable: true, },] : []),

    {
      name: "Action",
      cell: (row) => (
        <div className="dflex CPointer alignitems JCCenter" style={{ gap: "15px" }} >
          <FaRegEye title="Preview"
            onClick={() => {
              navigate(".", { state: { ...location.state, SList: CPage } });
              localStorage.setItem("SearchSid", SearchText);
              QuestionPreview(row, dispatch, navigate, location, true);
            }} />
          {/* {!CheckLanguage(SelectLanguage) && (
            <RiDeleteBin5Line style={{ color: "#FD3333" }} onClick={() =>  QuestionDelete(row.questionID, SetDMessage, dispatch) } />
          )} */}
          {/* <span className="LinkStyles" style={{ textWrap: "nowrap" }}
            // onClick={() => SetQuestionData(row.questionID)} title="View Question Activity Log" >
            <FaClockRotateLeft /> </span> */}
        </div>
      ),
    },
  ];

  const HandleQuestionDetails = (Qid) => {
         navigate(".", { state: { ...location.state, SList: CPage } });
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchSid", SearchText);
    }
    if (items.subjectId === "1") {
      GetQuestionDetails(SelectLanguage, Qid, dispatch, navigate, SetLoad, location, true);
    } else {
      GetScienceQuestionDetails(SelectLanguage, Qid, dispatch, navigate, SetLoad, location, true);
    }
  };
  return (
    <>
      {!props.data && (
        <>
          <div className="MainHeading">Scenario based Questions</div>
          <div className="Card mt-2">
            <div className="dflex JSBetween alignitems InputFIlters m-1">
              <label style={{ backgroundColor: "white" }}>Search</label>
              <div className="dflex gap-3">
                {["By Scenario Id(s)", "By Question Id(s)", "By Status"].map((element) => (
                  <span className="dflex alignitems gap-2">
                    <input type="radio" name="Search" value={element} checked={element == SearchSelection}
                      onChange={() => { ChangeFilter(element); }} /> {element} </span>
                ))}
              </div>

              {SearchSelection !== "By Status" ? (
                <div style={{ position: "relative", right: "100px" }}>
                  <Search Searchvalue={SearchText} onChange={(e) => SetSearchText(e.replace(/[^0-9,]/g, ""))}
                    placeholder={`Enter ${SearchSelection === "By Scenario Id(s)" ? "Scenario" : "Question"} Id(s)`} /></div>
              ) : (
                <div className="dflex p-2 QBFStuats">
                  {["Used", "Unused", "Mapped", "Unmapped", "NA"].map(
                    (Filter) => (
                      <div className="dflex alignitems gap-2" key={Filter} onChange={() => handleFilterChange(Filter)} >
                        <input type="checkbox" value={Filter} checked={SelectFilters.includes(Filter)} /> {Filter}
                      </div>
                    )
                  )}{" "}
                </div>
              )}

              <div className="dflex alignitems gap-2">
                <button className="Buttons" onClick={GetFilterData}> Go </button>
                <button className="Buttons" onClick={BacktoNormaList}>{SearchSelection === "By Question Id(s)" ? "Back to scenarios" : "Clear Filters"}</button>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="dflex mt-3 alignitems JSBetween">
        <div className="SubHeading">{SearchSelection === "By Question Id(s)" ? "Questions" : "Scenarios"}</div>
        {props.data || CheckLanguage(parseInt(SelectLanguage)) || SearchSelection === "By Question Id(s)" ? (<div></div>) : (
          <button className="Buttons AddButton dflex alignitems JCCenter"
            onClick={() => {
              navigate("/QBAdmin/QuestionBank/AddEditScenario");
              dispatch(ScenarioData({ ScenarioDetails: "" }));
            }} > <HiMiniPlusSmall /> Add Scenario </button>
        )}
      </div>
      <div className="Card mt-2">
        {ScenarioList?.[0]?.scenarioID || ScenarioList?.[0]?.questionID ? (
          <DataTable data={ScenarioList} GetCurrentPage={SetCPage}
            columns={SearchSelection === "By Question Id(s)" ? QuestionBased : columns} className="NCLDataTable"
            TotalRecords={props.data ? "" : ScenarioList[0]?.totalScenario || ScenarioList?.length}
            CountPage={SetPageCount} ShowPagination={true} ShowPagecount={true} 
            // CCpage = {CPage}
            NoPage={props.data ? "" : CPage} Dropdownvalues={["10", "25", "50", "100"]}
            hitapi={props.data ? "" : SearchSelection !== "By Question Id(s)" && ScenariosBySubject} /> 
        ) : (<div className="ErrorMessage">{ScenarioList}</div>)}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default Scenario;